import React from 'react';
import { SRow, SIcon } from '@avalara/skylab-sdk/react';
const OrderSummaryHeader = ({ offerFlow }) => {
    const styles = {
        color: offerFlow === 'avalara-for-shopify' ? '#ffffff' : 'black',
    };
    return (React.createElement("div", { className: 'order-summary pad-right-sm' },
        React.createElement(SRow, { className: 'space-between' },
            React.createElement("span", { "data-ref": 'buydot.order-summary-header', style: styles }, "Order summary"),
            React.createElement(SIcon, { "data-ref": 'buydot.order-summary-header.cart-icon', name: 'shopping-cart', style: styles, className: 'right pad-right-sm' }))));
};
export default OrderSummaryHeader;
